import { createFileRoute } from '@tanstack/react-router'
import ArtigoNovoPage from '@/pages/sites/artigo-novo-page'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

// Rota para editar artigo existente
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sites/$siteId/blog/$artigoId/',
)({
  component: function ArtigoEditarRoute() {
    const { dashboardId, siteId, artigoId } = Route.useParams()

    return (
      <ProtectedRoute capability={CAPABILITIES.MANAGE_SITES_BLOG}>
        <ArtigoNovoPage
          dashboardId={dashboardId}
          siteId={siteId}
          artigoId={artigoId}
        />
      </ProtectedRoute>
    )
  },
})
